export default __webpack_public_path__ + "be4bed0335370f9978e67e4941240112.png";